import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
  import LotMapsWithStageInterface from "@/types/LotMapsWithStageInterface";
  import { useStore } from "vuex";
  import StageButtonLink from "@/v2/components/stage/StageButtonLink.vue";
  import LotButtonLink from "@/v2/components/Lot/LotButtonLink.vue";
  import { LotInterface } from "@/types/LotInterface";
  import { LotMapInterface } from "@/types/LotMapInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'MapSidePanel',
  props: {
    estateId: { type: String, required: true, default: "" },
    isStageMap: { type: Boolean, required: false, default: false },
    stageId: { type: String, required: false, default: "" },
    hoverStageId: { type: String, required: false, default: "" },
    hoverLotId: { type: String, required: false, default: "" },
    lotsByHouseDesigns: { type: Array, required: false, default: undefined },
    builderView: { type: Boolean, required: false },
    hideOptions: { type: Boolean, required: false },
  },
  emits: [
    "onMessage",
    "onStageHover",
    "onStageClick",
    "onLotHover",
    "onLotClick",
    "onRegister",
    "onMessage",
    "toMasterplan",
    "onLotBuilderHover",
  ],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const loading = ref(true);
  const store = useStore();
  const lotsList = ref<LotMapsWithStageInterface[]>([]);

  const props = __props;

  const emits = __emit;

  const actualStage = computed(() =>
    lotsList.value.filter((l) => l.stage.id === props.stageId)
  );

  const onStageClick = (id: string) => {
    emits("onStageClick", id);
  };

  const onStageHover = (value: boolean, id: string) => {
    emits("onStageHover", value, id);
  };

  const onLotClick = (lot: LotMapInterface) => {
    emits("onLotClick", lot);
  };

  const onLotHover = (value: boolean, id: string) => {
    emits("onLotHover", value, id);
  };

  const onLotBuilderHover = (value: boolean, id: string) => {
    emits("onLotBuilderHover", value, id);
  };

  const getLotsList = () => {
    store
      .dispatch("lot/getLotsList", {
        estateId: props.estateId,
        isCustomer: true,
      })
      .then(async (res) => {
        lotsList.value = res.data;
        await getLotsListFiltered();
      })
      .finally(() => {
        loading.value = false;
      });
  };

  const getLotsListFiltered = async () => {
    if (props.lotsByHouseDesigns) {
      let houseDesignIds: string[] = props.lotsByHouseDesigns.map(
        (design) => design._id
      );

      lotsList.value = lotsList.value.map((lot) => {
        const matchingLotData = lot.lotData.filter((lotData) =>
          houseDesignIds.includes(lotData.lotId._id)
        );

        return { ...lot, lotData: matchingLotData };
      });
    }
  };

  onMounted(() => {
    getLotsList();
  });

const __returned__ = { loading, store, lotsList, props, emits, actualStage, onStageClick, onStageHover, onLotClick, onLotHover, onLotBuilderHover, getLotsList, getLotsListFiltered, computed, onMounted, ref, get LotMapsWithStageInterface() { return LotMapsWithStageInterface }, get useStore() { return useStore }, StageButtonLink, LotButtonLink, get LotInterface() { return LotInterface }, get LotMapInterface() { return LotMapInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})